import type { SrSalesOrderType } from '@plato/data/starrocks/types';
import { SearchEntity } from '@plato/search/search-types';
import { Button } from '@plato/ui-legacy/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@plato/ui/containers/dropdown-menu';
import { EllipsisVerticalIcon } from 'lucide-react';
import { useCustomerBasis } from '../../customer-detail/hooks/use-customer-basis.ts';
import { DropdownMenuItemCreateTask } from '../../tasks/components/dropdown-menu-item-create-task.tsx';
import { DropdownMenuItemDelete, DropdownMenuItemRelease } from './quote-order-dropdown-menu-items.tsx';

type Props = {
    type: SrSalesOrderType;
    transactionId: string;
    customerId: string;
    onDelete?: () => void;
};

export function QuoteOrderActionDropdownMenu({ onDelete, transactionId, type, customerId }: Props) {
    const { data: customerBasis, isLoading } = useCustomerBasis({
        customerId,
    });

    return (
        <div className="relative">
            <DropdownMenu>
                <DropdownMenuTrigger
                    render={
                        <Button
                            variant="icon"
                            icon={EllipsisVerticalIcon}
                            isLoading={isLoading}
                            disabled={isLoading}
                            isDisabled={isLoading}
                        />
                    }
                />
                <DropdownMenuContent align="end" className="empty:hidden">
                    <DropdownMenuItemCreateTask
                        links={[
                            {
                                modelId: transactionId,
                                modelType:
                                    type === 'ORDER' ? SearchEntity.SalesOrder : SearchEntity.SalesQuote,
                                title: transactionId,
                            },
                            {
                                modelId: customerId,
                                modelType: SearchEntity.Customer,
                                title: customerBasis?.customerName || '',
                            },
                        ]}
                        source="quote_order_detail"
                    />
                    <DropdownMenuItemRelease transactionId={transactionId} type={type} />
                    <DropdownMenuItemDelete onDelete={onDelete} transactionId={transactionId} type={type} />
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
